export const postBridgeMessage = (msg) => {
  const data = JSON.stringify(msg);
  try {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(data);
    } else {
      window.chrome?.webview?.postMessage(data);
    }
  } catch {}
};
